import React, { useState } from "react";
import "../App.css";
import { useLocation, useHistory } from "react-router-dom";
import { Button } from "reactstrap";
import MyStorage from "./util/storage";
import Api from "./api/api";

const UserDetails = () => {
  const location = useLocation();
  const user = location.state.user;
  const history = useHistory();
  const [status, setStatus] = useState(user.status);
  const [freeUser, setFreeUser] = useState(user.free_user);

  const updateStatus = (status) => {
    Api.updateStatus(
      user.id,
      status,
      (response) => {
        //
      },
      (error) => {
        //
      }
    );
  };

  const updateFreeStatus = (status) => {
    Api.updateFreeStatus(
      user.id,
      status,
      (response) => {
        //
      },
      (error) => {
        //
      }
    );
  };

  const deleteUser = () => {
    Api.deleteUser(
      user.id,
      (response) => {
        history.goBack();
      },
      (error) => {
        history.goBack();
      }
    );
  };

  const getProfilePhoto = (model) => {
    if (
      MyStorage.getFileUrls() == null ||
      model.photo == null ||
      model.photo === ""
    ) {
      return user;
    } else {
      if (model.photo.includes("http")) {
        return model.photo;
      }
      return MyStorage.getFileUrls().User + model.photo;
    }
  };

  return (
    <div className="main">
      <div
        className="titlebar"
        style={{ backgroundColor: "#f2f2f2", padding: 10, margin: -15 }}
      >
        <div style={{ color: "blue" }}>User Details</div>
      </div>
      <div
        style={{
          marginTop: 30,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <img src={getProfilePhoto(user)} style={{ width: 100, height: 100 }} />
        <div
          style={{
            display: "flex",
            width: "100%",
            marginTop: 20,
            alignItems: "center",
            justifyContent: "center",
            flexDirection: "column",
          }}
        >
          <div
            style={{
              padding: 8,
              backgroundColor: "#F2F2F2",
              width: 500,
              display: "flex",
            }}
          >
            <div style={{ color: "gray", marginRight: 10 }}>Name:</div>{" "}
            {user.fname} {user.lname}
          </div>
          <div
            style={{
              padding: 8,
              backgroundColor: "#ffffff",
              width: 500,
              display: "flex",
            }}
          >
            <div style={{ color: "gray", marginRight: 10 }}>Email:</div>{" "}
            {user.email}
          </div>
          <div
            style={{
              padding: 8,
              backgroundColor: "#F2F2F2",
              width: 500,
              display: "flex",
            }}
          >
            <div style={{ color: "gray", marginRight: 10 }}>Phone:</div>{" "}
            {user.phone}
          </div>
          <div
            style={{
              padding: 8,
              backgroundColor: "#ffffff",
              width: 500,
              display: "flex",
            }}
          >
            <div style={{ color: "gray", marginRight: 10 }}>Status:</div>
            <div style={{ flex: 1, justifyContent: "center" }}>
              <select
                value={status}
                name="status"
                id="status"
                style={{
                  alignSelf: "flex-end",
                  display: "flex",
                  marginLeft: 10,
                }}
                onChange={(event) => {
                  console.log("change");
                  setStatus(event.target.value);
                  updateStatus(event.target.value);
                }}
              >
                <option value="activated">Active</option>
                <option value="suspended">Suspended</option>
              </select>
            </div>
          </div>
          <div
            style={{
              padding: 8,
              backgroundColor: "#F2F2F2",
              width: 500,
              display: "flex",
            }}
          >
            <div style={{ color: "gray", marginRight: 10 }}>
              Free Access to Library:
            </div>
            <div style={{ flex: 1, justifyContent: "center" }}>
              <select
                value={freeUser}
                name="access"
                id="acess"
                style={{
                  alignSelf: "flex-end",
                  display: "flex",
                  marginLeft: 10,
                }}
                onChange={(event) => {
                  setFreeUser(event.target.value);
                  updateFreeStatus(event.target.value);
                }}
              >
                <option value="0">No</option>
                <option value="1">Yes</option>
              </select>
            </div>
          </div>
          <div
            style={{
              padding: 8,
              backgroundColor: "#ffffff",
              width: 500,
              display: "flex",
            }}
          >
            <div style={{ color: "gray", marginRight: 10 }}>Member:</div>{" "}
            {user.subscriber === "1" ? "Yes" : "No"}
          </div>
          <div
            style={{
              padding: 8,
              backgroundColor: "#F2F2F2",
              width: 500,
              display: "flex",
            }}
          >
            <div style={{ color: "gray", marginRight: 10 }}>Joined:</div>{" "}
            {user.added_date}
          </div>

          <div style={{ display: "flex", marginTop: 20 }}>
            <Button
              className="btn-block btn-submit"
              style={{
                width: 150,
                marginRight: 10,
                backgroundColor: "green",
                borderWidth: 0,
                fontSize: 16,
              }}
              onClick={() => {
                console.log("click");
                history.push({
                  pathname: "/send-email",
                  state: { user: user },
                });
              }}
            >
              Send Email
            </Button>
            <Button
              className="btn-block btn-submit"
              style={{
                width: 200,
                marginRight: 10,
                backgroundColor: "blue",
                borderWidth: 0,
                fontSize: 16,
              }}
              onClick={() => {
                console.log("click");
                history.push({
                  pathname: "/send-notification",
                  state: { user: user },
                });
              }}
            >
              Send Notification
            </Button>
            <Button
              className="btn-block btn-submit"
              style={{
                width: 150,
                marginRight: 10,
                backgroundColor: "purple",
                borderWidth: 0,
                fontSize: 16,
              }}
              onClick={() => {
                console.log("click");
                history.push({
                  pathname: "/chat",
                  state: { model: { user: user } },
                });
              }}
            >
              Chat
            </Button>
            <Button
              className="btn-block btn-submit"
              style={{
                width: 150,
                backgroundColor: "red",
                borderWidth: 0,
                fontSize: 16,
              }}
              onClick={() => {
                console.log("click");
                if (
                  window.confirm("Are you sure you wish to delete this user?")
                )
                  deleteUser();
              }}
            >
              Delete
            </Button>
          </div>
          <Button
            className="btn-block btn-submit"
            style={{
              width: 250,
              marginTop: 10,
              backgroundColor: "gray",
              borderWidth: 0,
              fontSize: 16,
            }}
            onClick={() => {
              console.log("click");
              history.push({
                pathname: "/user-admin-assignments",
                state: { user: user },
              });
            }}
          >
            View Admin Assignments
          </Button>
        </div>
      </div>
    </div>
  );
};

export default UserDetails;
